__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/94d6769e2e1c26615adca4cf5eefd665bf84e92c/_next/";